import { render, staticRenderFns } from "./stati.vue?vue&type=template&id=32dcb3a5&"
import script from "./stati.vue.ts?vue&type=script&lang=ts&"
export * from "./stati.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports